<template>
<div>
  <div class="form-group">
    <label>Product Name: </label>
    <h3>
      <b>{{ product_details.name }}</b>
    </h3>
  </div>

  <div class="form-group">
    <label>Description</label>
    <!-- <textarea rows="10" class = "form-control" v-model = "product_details.description" placeholder = "Product Description">
      </textarea> -->
    <div id="app">
      <ckeditor :editor="editor" v-model="product_details.description" :config="editorConfig"></ckeditor>
    </div>
  </div>

  <hr />

  <div class="form-group">
    <label>Add survey</label>
    <select class="form-control" v-model="selectedSurvey">
      <option value="">Select Survey</option>
      <option v-for="(survey, index) in activeSurveys" :key="index" :value="survey.survey_id">{{ survey.title }}
      </option>
    </select>
    <p class="text-primary font-weight-bold">Please select available survey from the list</p>
    <button class="btn btn-primary" @click="addSurvey()">
      Add Survey to Product
    </button>
  </div>

  <hr>

  <div class="form-group">
      <label>Upload Product Wording</label>
      <input
        type="file"
        ref="product_wording"
        v-on:change="handleProductWordingUpload"
        class="form-control"
      />
      <br />
      <progress max="100" :value.prop="uploadProductWordingPercentage"></progress>
      <br />
      <button
        class="btn btn-primary"
        @click="
          downloadProductWording(product_details.id, product_details.product_wording_link)
        "
      >
        Download Product Wording
      </button>
  </div>

  <hr />

  <div class="form-group">
    <label>Upload Brochure</label>
    <input type="file" ref="brochure" v-on:change="handleBrochureUpload" class="form-control" />
    <br />
    <progress max="100" :value.prop="uploadBrochurePercentage"></progress>
    <br />
    <button class="btn btn-primary" @click="
      downloadBrochure(product_details.id, product_details.brochure_link)
      ">
      Download Brochure
    </button>
  </div>

  <hr />

  <div class="form-group">
    <label>Upload Product Disclosure</label>
    <input type="file" ref="product_disclosure" v-on:change="handleDisclosureUpload" class="form-control" />
    <br />
    <progress max="100" :value.prop="uploadDisclosurePercentage"></progress>
    <br />
    <button class="btn btn-primary" @click="
      downloadDisclosure(
        product_details.id,
        product_details.product_disclosure
      )
      ">
      Download Product Disclosure
    </button>
  </div>

  <hr />

  <div class="form-group">
    <label>Upload Banner</label>
    <input type="file" ref="banner" v-on:change="handleBannerUpload" class="form-control" />
    <br />
    <progress max="100" :value.prop="uploadBannerPercentage"></progress>
    <br />
    <img :src="getBanner" />
  </div>

  <div class="form-group">
    <label>Upload Participation Banner</label>
    <input type="file" ref="participation_banner" v-on:change="handleParticipationBannerUpload" class="form-control" />
    <br />
    <progress max="100" :value.prop="uploadParticipationBannerPercentage"></progress>
    <br />
    <img :src="getParticipationBanner" />
  </div>

  <input type="submit" class="btn btn-primary  mb-2" @click="handleSubmit" />

</div>
</template>

<script>
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { global } from "@/global";

export default {
  name: "product_detail",
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      product_details: {
        id: "",
        name: "",
        description: "",
        brochure_link: "",
        product_wording_link: "",
      },
      brochure: "",
      productDisclosure: "",
      product_wording: "",
      banner: "",
      participation_banner: "",
      uploadBrochurePercentage: 0,
      uploadDisclosurePercentage: 0,
      uploadBannerPercentage: 0,
      uploadProductWordingPercentage: 0,
      uploadParticipationBannerPercentage: 0,
      editor: ClassicEditor,
      editorConfig: {
      },

      activeSurveys: [],
      selectedSurvey: '',
    }
  },

  methods: {
    loadProductDetails() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/products/" + this.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.product_details = res.data;
          });
      }
    },

    handleBrochureUpload() {
      this.brochure = this.$refs.brochure.files[0];
    },

    handleProductWordingUpload() {
      this.product_wording = this.$refs.product_wording.files[0];
    },

    handleBannerUpload() {
      this.banner = this.$refs.banner.files[0];
    },

    handleParticipationBannerUpload() {
      this.participation_banner = this.$refs.participation_banner.files[0];
    },

    handleDisclosureUpload() {
      this.productDisclosure = this.$refs.product_disclosure.files[0];
    },


    handleSubmit() {
      let success = true;

      if (this.brochure !== "") {
        success = false;
        this.update("brochure");
      }

      if (this.banner !== "") {
        success = false;
        this.update("banner");
      }

      if (this.participation_banner !== "") {
        success = false;
        this.update("participation_banner");
      }

      if (this.productDisclosure !== "") {
        success = false;
        this.update("product_disclosure");
      }

      if (this.product_wording !== "") {
        success = false;
        this.update("policy_wording");
      }


      if (success) {
        this.updateProduct();
      }
    },

    update(fileType) {
      let token = localStorage.getItem("token");

      this.id = this.$route.params.id;

      let formdata = new FormData();

      if (fileType === "brochure") {
        formdata.append(fileType, this.brochure);
      } else if (fileType === "banner") {
        formdata.append(fileType, this.banner);
      } else if (fileType === "participation_banner") {
        formdata.append(fileType, this.participation_banner);
      } else if (fileType === "product_disclosure") {
        formdata.append(fileType, this.productDisclosure);
      } else if (fileType === "policy_wording") {
        formdata.append(fileType, this.product_wording);
      }

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post("/products/" + this.id + "/" + fileType, formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: function (progressEvent) {
              if (fileType === "banner") {
                this.uploadBannerPercentage = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              }

              if (fileType === "participation_banner") {
                this.uploadParticipationBannerPercentage = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              }

              if (fileType === "brochure") {
                this.uploadBrochurePercentage = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              }

              if (fileType === "disclosure") {
                this.uploadDisclosurePercentage = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              }
              if (fileType === "policy_wording") {
                this.uploadProductWordingPercentage = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
              }
            }.bind(this)
          })
          .then(res => {
            if (res.data.success) {
              this.updateProduct();
            } else {
              swal({
                text: res.data.message,
                icon: "warning",
                button: "OK"
              });
              return false;
            }
          })
          .catch(function () {
            console.log("Fail to upload");
          });
      }
    },

    updateProduct() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios.patch("/products/" + this.id,
          {
            description: this.product_details.description,
            // survey_id: ''
          },
          {
            headers: {
              'Authorization': 'Bearer ' + token
            }
          })
          .then(res => {
            if (!res.data.success) {
              swal({
                text: "Update Fail! " + res.data.message,
                icon: "error",
                button: "OK"
              })
            } else {
              swal({
                text: "Update Successful",
                icon: "success",
                button: "OK"
              })
              this.product = res.data.product
              this.loadProductDetails()
            }
          })
      }
    },

    downloadBrochure(id, link) {
      let token = localStorage.getItem("token");

      if (link !== null) {
        let arrLink = link.split("/");

        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;

          axios
            .get("/products/" + id + "/brochure", {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            })
            .then(res => {
              this.brochure = res.data;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", arrLink[2]);
              document.body.appendChild(link);
              link.click();
            });
        }
      } else {
        swal({
          icon: "warning",
          text: "File is not found"
        });
      }
    },

    downloadProductWording(id, link) {
      let token = localStorage.getItem("token");

      if (link !== null) {
        let arrLink = link.split("/");

        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;

          axios
            .get("/products/" + id + "/policy_wording", {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            })
            .then(res => {
              this.product_wording = res.data;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", arrLink[2]);
              document.body.appendChild(link);
              link.click();
            });
        }
      } else {
        swal({
          icon: "warning",
          text: "File is not found"
        });
      }
    },

    downloadDisclosure(id, link) {
      let token = localStorage.getItem("token");

      if (link !== null) {
        let arrLink = link.split("/");

        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;

          axios
            .get("/products/" + id + "/product_disclosure", {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            })
            .then(res => {
              this.productDisclosure = res.data;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", arrLink[2]);
              document.body.appendChild(link);
              link.click();
            });
        }
      } else {
        swal({
          icon: "warning",
          text: "File is not found"
        });
      }
    },

    downloadWording(id, link) {
      let token = localStorage.getItem("token");

      if (link !== null) {
        let arrLink = link.split("/");

        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;

          axios
            .get("/products/" + id + "/policy_wording", {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            })
            .then(res => {
              this.productDisclosure = res.data;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", arrLink[2]);
              document.body.appendChild(link);
              link.click();
            });
        }
      } else {
        swal({
          icon: "warning",
          text: "File is not found"
        });
      }

    },

    addSurvey() {
      let token = localStorage.getItem('token')
      this.id = this.$route.params.id



      // check if has token
      if (token !== null) {
        token = JSON.parse(token)
        token = token.access_token

        axios.patch("/products/" + this.id,
          {
            survey_id: this.selectedSurvey,
          },
          {
            headers: {
              'Authorization': 'Bearer ' + token
            }
          })
          .then(res => {
            if (!res.data.success) {
              swal({
                text: "Update Fail! " + res.data.message,
                icon: "error",
                button: "OK"
              })
            } else {
              swal({
                text: "Update Successful",
                icon: "success",
                button: "OK"
              })

              this.product = res.data.product
              this.loadProductDetails()
            }
          })

      }
    },

    async getSurvey() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios
            .get(axios.lpsURL + "/survey_user/status/1", {
              headers: {
                Authorization: "Bearer " + token
              }
            });
          result.data.forEach(element => {
            this.activeSurveys.push({ survey_id: element.id, title: element.survey_title })
          });
          console.log(JSON.stringify(this.activeSurveys))
        } catch (error) {
          console.log(error)
        }

      }
    },
  },

  computed: {
    getBanner() {
      return global.url + `/products/${this.$route.params.id}/banner`;
    },

    getParticipationBanner() {
      return global.url + `/products/${this.$route.params.id}/participation_banner`;
    }
  },

  async created() {
    await this.getSurvey();
  },

  mounted() {
    this.loadProductDetails()
  }
};
</script>
